export const italiano = {
    modulo: 'Ticket',
    hardware: {
        titolo: 'Apparecchiatura hardware',
        descrizione: 'Crea una nuova richiesta hardware'
    },
    software: {
        titolo: 'Apparecchiatura software',
        descrizione: 'Crea una nuova richiesta software'
    },
    elenco: {
        titolo: 'Elenco richieste',
        descrizione: 'Visualizza le richieste fatte',
        dettagliRichiesta: 'Dettagli richiesta',
        dataTable: {
            numero: 'Numero',
            data: 'Data',
            numMacchina: 'Num. macchina',
            matricola: 'Matricola',
            modello: 'Modello',
            ubicazione: 'Ubicazione',
            tipoRichiesta: 'Tipo richiesta',
            tipoIntervento: 'Tipo intervento',
            utente: 'Utente',
            stato: 'Stato',
            descrizione: 'Descrizione',
            motivoRifiuto: 'Motivo rifiuto',
        }
    },
    selezionaMatricola: {
        selezionaSede: 'Seleziona la sede',
        selezionaMatricola: 'Seleziona la matricola'
    },
    tipoRichiesta: {
        dettagli: 'Aggiungi ulteriori dettagli che possono esserci utili',
        dettagliPlaceholder: 'Ulteriori dettagli...',
        inCorso: 'Richieste in corso',
        noChiamateTitolo: 'Nessuna chiamata aperta',
        noChiamateDescrizione: 'Non è presente nessuna chiamata aperta per la macchina selezionata',
        errorMessage: 'Per proseguire selezionare un tipo richiesta ed inserire la descrizione aggiuntiva'
    },
    riepilogo: {
        referente: 'Referente',
    }
}

export const inglese = {
    modulo: 'Ticket',
    hardware: {
        titolo: 'Apparecchiatura hardware',
        descrizione: ''
    },
    software: {
        titolo: 'Apparecchiatura software',
        descrizione: ''
    },
    elenco: {
        titolo: '',
        descrizione: '',
        dettagliRichiesta: 'Dettagli richiesta',
        dataTable: {
            numero: 'Numero',
            data: 'Data',
            numMacchina: 'Num. macchina',
            matricola: 'Matricola',
            modello: 'Modello',
            ubicazione: 'Ubicazione',
            tipoRichiesta: 'Tipo richiesta',
            tipoIntervento: 'Tipo intervento',
            utente: 'Utente',
            stato: 'Stato',
            descrizione: 'Descrizione',
            motivoRifiuto: 'Motivo rifiuto',
        }
    },
    selezionaMatricola: {
        selezionaSede: 'Seleziona la sede',
        selezionaMatricola: 'Seleziona la matricola'
    },
    tipoRichiesta: {
        dettagli: 'Aggiungi ulteriori dettagli che possono esserci utili',
        dettagliPlaceholder: 'Ulteriori dettagli...',
        inCorso: 'Richieste in corso',
        noChiamateTitolo: 'Nessuna chiamata aperta',
        noChiamateDescrizione: 'Non è presente nessuna chiamata aperta per la macchina selezionata',
        errorMessage: 'Per proseguire selezionare un tipo richiesta ed inserire la descrizione aggiuntiva'
    },
    riepilogo: {        
        referente: 'Referente',
    }
}